import { CARD_PATTERNS } from '../../constants/patterns';
import {
  PAYMENT_TYPE_AMEX,
  PAYMENT_TYPE_DINERS,
  PAYMENT_TYPE_DISCOVER,
  PAYMENT_TYPE_MC,
  PAYMENT_TYPE_VISA,
  PAYMENT_TYPE_STAR,
  PAYMENT_TYPE_NYCE,
  PAYMENT_TYPE_PULSE,
} from 'webapp-common-ui/src/constants';

export default function getCardTypeFromNumber(cardNumber) {
  const numberStr = cardNumber.replace(/\s/g, '');

  if (CARD_PATTERNS.VISA.test(numberStr)) {
    return PAYMENT_TYPE_VISA;
  }

  if (CARD_PATTERNS.AMERICAN_EXPRESS.test(numberStr)) {
    return PAYMENT_TYPE_AMEX;
  }

  if (CARD_PATTERNS.MASTERCARD.test(numberStr)) {
    return PAYMENT_TYPE_MC;
  }

  if (CARD_PATTERNS.DISCOVER.test(numberStr)) {
    return PAYMENT_TYPE_DISCOVER;
  }

  if (CARD_PATTERNS.DINERS.test(numberStr)) {
    return PAYMENT_TYPE_DINERS;
  }

  if (CARD_PATTERNS.STAR.test(numberStr)) {
    return PAYMENT_TYPE_STAR;
  }

  if (CARD_PATTERNS.NYCE.test(numberStr)) {
    return PAYMENT_TYPE_NYCE;
  }

  if (CARD_PATTERNS.PULSE.test(numberStr)) {
    return PAYMENT_TYPE_PULSE;
  }

  return null;
}
